import { Component, signal } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';
import { NgClass } from '@angular/common';
import { TooltipPosition } from '../../../../core/directives/tooltip';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-ag-grid-tooltip',
  imports: [TranslateModule, NgClass],
  templateUrl: './ag-grid-tooltip.component.html',
})
export class AgGridTooltipComponent implements ITooltipAngularComp {
  tooltip = signal<string>('');
  position = signal<TooltipPosition>(TooltipPosition.BELOW);

  agInit(params: { position?: TooltipPosition } & ITooltipParams): void {
    this.refresh(params);
  }

  refresh(params: { position?: TooltipPosition } & ITooltipParams): boolean {
    this.tooltip.set(params.value.fullName ? params.value.fullName.trim() : params.value);
    this.position.set(params.position || TooltipPosition.BELOW);
    return true;
  }
}
